import { Box, Divider, Typography } from "@material-ui/core"

const TituloSeccion = ({titulo}) => {
    return (
        <>
        <Box mt={5} mb={3} mx={2}>
            {/* <Typography gutterBottom style={{ fontWeight: 500, marginTop: 32 }} variant="h6"> */}

            <Typography variant="h5" component="h3" gutterBottom style={{fontWeight: 500}} >
                {titulo}
            </Typography>
        </Box>
        </>
    )
}

export default TituloSeccion